import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('DataUsageList').create(() => ({
  root: {
    '& > :first-child': {
      borderTopRightRadius: '12px',
      borderTopLeftRadius: '12px',
    },
    '& > :last-child': {
      borderBottomRightRadius: '12px',
      borderBottomLeftRadius: '12px',
    },
  },
}))
